import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { Provider, useSelector } from "react-redux";
// react library for routing
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import store from "./redux/store";

// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "@fullcalendar/core/vdom";
import "@fullcalendar/common/main.min.css";
import "@fullcalendar/daygrid/main.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "select2/dist/css/select2.min.css";
import "quill/dist/quill.core.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// plugins styles downloaded
import "assets/vendor/nucleo/css/nucleo.css";
// core styles
import "assets/scss/argon-dashboard-pro-react.scss?v1.2.1";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/nprogress/styles.css";
// import "@mantine/modals/styles.css";
import "@mantine/carousel/styles.css";

import { MantineProvider } from "@mantine/core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NuqsAdapter } from "nuqs/adapters/react-router/v6";

import Analytics from "./Analytics";
import AppLoading from "./app_loading";
import SDATransitionAnnouncementModal from "./components/SDATransitionAnnouncementModal";
import router from "./routes";
import { theme } from "./theme";

// Main App wrapper component to handle loading state
const AppWithLoading = () => {
	const [showLoading, setShowLoading] = useState(true);
	const [isFirstTime, setIsFirstTime] = useState(true);

	useEffect(() => {
		// Check if user has visited before
		const hasVisited = localStorage.getItem("hasVisitedBefore");

		if (hasVisited === "true") {
			setIsFirstTime(false);
			setShowLoading(false);
		} else {
			setIsFirstTime(true);
			setShowLoading(true);
		}
	}, []);

	const handleLoadingComplete = () => {
		setShowLoading(false);
	};

	if (isFirstTime && showLoading) {
		return <AppLoading onLoadingComplete={handleLoadingComplete} />;
	}

	return (
		<MantineProvider theme={theme}>
			<Provider store={store}>
				<Analytics />
				<QueryClientProvider client={queryClient}>
					<ToastContainer
						position="top-center"
						autoClose={3000}
						hideProgressBar={true}
						newestOnTop={false}
						closeOnClick
						rtl={false}
						pauseOnFocusLoss
						draggable
						pauseOnHover
						theme="colored"
					/>

					<NuqsAdapter>
						{/* Add your provider here */}
						{/* <YourProvider> */}
						<RouterProvider router={router}></RouterProvider>
						{/* </YourProvider> */}
						<SDATransitionAnnouncementModal />
					</NuqsAdapter>
				</QueryClientProvider>
			</Provider>
		</MantineProvider>
	);
};

const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: false,
		},
	},
});

root.render(<AppWithLoading />);
